var _circle, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 34,
    fill: "#282828",
    stroke: "url(#paint0_linear_4200_12255)",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.1997 40.2217C48.7399 45.9296 43.2776 48.7834 35.813 48.7834C28.3482 48.7834 22.8741 45.9296 19.3906 40.2217L22.5898 36.9533C24.296 38.8954 26.1681 40.2927 28.2061 41.1453C30.2441 41.9979 32.7797 42.4243 35.813 42.4243C38.8463 42.4243 41.3759 41.9979 43.402 41.1453C45.4282 40.2927 47.2943 38.8954 49.0005 36.9533L52.1997 40.2217ZM32.9687 31.8375C32.9687 33.2349 32.5067 34.2947 31.5825 35.0172C30.6582 35.7395 29.4734 36.1007 28.0278 36.1007C26.369 36.1007 24.8701 35.6448 23.5312 34.7329C22.1923 33.821 21.1674 32.5007 20.4565 30.7718L22.4827 27.7166C22.9803 28.9244 23.5431 29.931 24.1711 30.7362C24.7991 31.5415 25.5277 32.1099 26.3571 32.4415L26.4993 32.2993C26.1913 31.9914 26.0372 31.6126 26.0372 31.1626C26.0372 30.2863 26.3217 29.5165 26.8904 28.8533C27.4591 28.1902 28.2647 27.8587 29.3075 27.8587C30.516 27.8587 31.4284 28.2139 32.0446 28.9244C32.6607 29.6349 32.9687 30.606 32.9687 31.8375ZM37.3059 31.9796C37.3059 30.7244 37.614 29.7416 38.2301 29.0311C38.8463 28.3204 39.7112 27.9652 40.825 27.9652C41.9387 27.9652 42.8037 28.3204 43.4198 29.0311C44.036 29.7416 44.3441 30.7244 44.3441 31.9796C44.3441 33.2349 44.03 34.2118 43.402 34.9105C42.774 35.6092 41.9151 35.9586 40.825 35.9586C39.7112 35.9586 38.8463 35.6092 38.2301 34.9105C37.614 34.2118 37.3059 33.2349 37.3059 31.9796Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4200_12255",
    x1: -14.7938,
    y1: 43.3969,
    x2: 72,
    y2: 43.3969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF56E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#225EFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6c2e53736ad8f583c36fb7c7a6d2ad96.svg";
export { ForwardRef as ReactComponent };